import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div
              className="footer-content"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <h3>Sibi Karthik C V</h3>
              <div className="footer-tagline" style={{ marginBottom: 12 }}>
                AI/ML Engineer | Data Scientist | Computer Vision | Sports
                Analytics | Statistics
              </div>
              <div className="footer-socials" style={{ marginTop: 0 }}>
                <a
                  href="https://instagram.com/sibi.karthik_"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                >
                  <i className="bi bi-instagram"></i>
                </a>
                <a
                  href="https://linkedin.com/in/sibi-karthik-c-v/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                >
                  <i className="bi bi-linkedin"></i>
                </a>
                <a
                  href="https://github.com/sibi15"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                >
                  <i className="bi bi-github"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
